import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'container', 'backdrop' ]

  connect() {
    this.element[this.identifier] = this
    this.hiddenClass = 'hidden'
    this.closeEvent = 'popupClosed'
    this.openEvent = 'popupOpened'
    this.openOnStart = this.element.dataset.show == 'true'
    if (this.openOnStart) this.open()
  }

  disconnect() {
    this.close()
  }

  open(e = null, param = null) {
    if (e) e.preventDefault()

    this.containerTarget.classList.remove(this.hiddenClass)
    this.backdropTarget.classList.remove(this.hiddenClass)
    this.trigger(this.openEvent, param)
  }

  close(e = null) {
    if (e) e.preventDefault()

    this.containerTarget.classList.add(this.hiddenClass)
    this.backdropTarget.classList.add(this.hiddenClass)
    if (this.openOnStart) this.element.remove()

    this.trigger(this.closeEvent)
  }

  closeContainer(e) {
    if (e.target == this.containerTarget) {
      this.close(e)
    }
  }

  closeWithEsc(e) {
    if (e.keyCode === 27 && !this.containerTarget.classList.contains(this.hiddenClass)) {
      this.close(e)
    }
  }

  trigger(eventName, param = null) {
    const event = new CustomEvent(eventName, { bubbles: true, detail: { param: param } })
    window.dispatchEvent(event)
  }
}
